// auth.js
export const LOGOUT = 'LOGOUT'
export const SAVE_TOKEN = 'SAVE_TOKEN'
export const FETCH_USER = 'FETCH_USER'
export const FETCH_USER_SUCCESS = 'FETCH_USER_SUCCESS'
export const FETCH_USER_FAILURE = 'FETCH_USER_FAILURE'
export const UPDATE_USER = 'UPDATE_USER'

// feedback.js
export const RESPONSE_MSG = 'RESPONSE_MSG'
export const CLEAR_MSG = 'CLEAR_MSG'

// students.js
export const LOAD_STUDENTS = 'FETCH_STUDENTS'
export const ADD_STUDENT = 'ADD_STUDENT'
export const UPDATE_STUDENT = 'UPDATE_STUDENT'
export const DELETE_STUDENT = 'DELETE_STUDENT'
export const STUDENT_FAILURE = 'STUDENT_FAILURE'
export const STUDENT_LOADING = 'STUDENT_LOADING'

// oemployees,js
export const LOAD_OEMPLOYEES = 'FETCH_OEMPLOYEES'
export const ADD_OEMPLOYEE = 'ADD_OEMPLOYEE'
export const UPDATE_OEMPLOYEE = 'UPDATE_OEMPLOYEE'
export const DELETE_OEMPLOYEE = 'DELETE_OEMPLOYEE'
export const OEMPLOYEE_FAILURE = 'OEMPLOYEE_FAILURE'
export const OEMPLOYEE_LOADING = 'OEMPLOYEE_LOADING'


// teachers,js
export const LOAD_TEACHERS = 'FETCH_TEACHERS'
export const ADD_TEACHER = 'ADD_TEACHER'
export const UPDATE_TEACHER = 'UPDATE_TEACHER'
export const DELETE_TEACHER = 'DELETE_TEACHER'
export const TEACHER_FAILURE = 'TEACHER_FAILURE'
export const TEACHER_LOADING = 'TEACHER_LOADING'

// guardians,js
export const LOAD_GUARDIANS = 'FETCH_GUARDIANS'
export const MY_WARDS = 'MY_WARDS'
export const ADD_GUARDIAN = 'ADD_GUARDIAN'
export const UPDATE_GUARDIAN = 'UPDATE_GUARDIAN'
export const DELETE_GUARDIAN = 'DELETE_GUARDIAN'
export const GUARDIAN_FAILURE = 'GUARDIAN_FAILURE'
export const GUARDIAN_LOADING = 'GUARDIAN_LOADING'

// fees.js
export const LOAD_FEES = 'FETCH_FEES'
export const ADD_FEE = 'ADD_FEES'
export const UPDATE_FEE = 'UPDATE_FEES'
export const DELETE_FEE = 'DELETE_FEES'
export const FEE_FAILURE = 'FEE_FAILURE'
export const FEE_LOADING = 'FEE_LOADING'

// fees.js
export const LOAD_DISCOUNTS = 'FETCH_DISCOUNTS'
export const ADD_DISCOUNT = 'ADD_DISCOUNTS'
export const UPDATE_DISCOUNT = 'UPDATE_DISCOUNTS'
export const DELETE_DISCOUNT = 'DELETE_DISCOUNTS'
export const DISCOUNT_FAILURE = 'DISCOUNT_FAILURE'
export const DISCOUNT_LOADING = 'DISCOUNT_LOADING'

// terms.js
export const LOAD_TERMS = 'FETCH_TERMS'
export const ADD_TERM = 'ADD_TERMS'
export const UPDATE_TERM = 'UPDATE_TERMS'
export const DELETE_TERM = 'DELETE_TERMS'
export const TERM_FAILURE = 'TERM_FAILURE'
export const TERM_LOADING = 'TERM_LOADING'

// journals.incomes.js
export const LOAD_INCOMES = 'FETCH_INCOMES'
export const ADD_INCOME = 'ADD_INCOMES'
export const UPDATE_INCOME = 'UPDATE_INCOMES'
export const DELETE_INCOME = 'DELETE_INCOMES'
export const INCOME_FAILURE = 'INCOME_FAILURE'
export const INCOME_LOADING = 'INCOME_LOADING'

// journals.expenses.js
export const LOAD_EXPENSES = 'FETCH_EXPENSES'
export const ADD_EXPENSE = 'ADD_EXPENSES'
export const UPDATE_EXPENSE = 'UPDATE_EXPENSES'
export const DELETE_EXPENSE = 'DELETE_EXPENSES'
export const EXPENSE_FAILURE = 'EXPENSE_FAILURE'
export const EXPENSE_LOADING = 'EXPENSE_LOADING'

// classes.js
export const LOAD_CLASSES = 'FETCH_CLASSES'
export const ADD_CLASS = 'ADD_CLASS'
export const UPDATE_CLASS = 'UPDATE_CLASS'
export const DELETE_CLASS = 'DELETE_CLASS'
export const CLASS_FAILURE = 'ACYEAR_FAILURE'
export const CLASS_LOADING = 'ACYEAR_LOADING'
export const LOAD_MY_CLASSES = 'LOAD_MY_CLASSES'
export const LOAD_PROMOCLASSES = 'LOAD_PROMOCLASSES'


// academicYear.js
export const LOAD_ACYEARS = 'FETCH_ACYEARS'
export const ADD_ACYEAR = 'ADD_ACYEAR'
export const UPDATE_ACYEAR = 'UPDATE_ACYEAR'
export const DELETE_ACYEAR = 'DELETE_ACYEAR'
export const ACYEAR_FAILURE = 'ACYEAR_FAILURE'
export const ACYEAR_LOADING = 'ACYEAR_LOADING'

// subjects
export const LOAD_SUBJECTS = 'FETCH_SUBJECTS'
export const ADD_SUBJECT = 'ADD_SUBJECT'
export const UPDATE_SUBJECT = 'UPDATE_SUBJECT'
export const DELETE_SUBJECT = 'DELETE_SUBJECT'
export const SUBJECT_FAILURE = 'TERM_FAILURE'
export const SUBJECT_LOADING = 'TERM_LOADING'

//marks.js
export const LOAD_MARKS = 'FETCH_MARKS'
export const ADD_MARK = 'ADD_MARK'
export const MARK_FAILURE = 'MARK_FAILURE'
export const MARK_LOADING = 'MARK_LOADING'
export const SET_CS = 'SET_CS'
export const SET_ES = 'SET_ES'


//sms.js
export const LOAD_RECIPIENTS = 'LOAD_RECIPIENTS'
export const SMS_BALANCE = 'SMS_BALANCE'
export const SMS_FAILURE = 'SMS_FAILURE'
export const SMS_LOADING = 'SMS_LOADING'

//reports.js
export const LOAD_PERFRPTS = 'FETCH_PERFRPTS'
export const LOAD_TRPTS = 'FETCH_TRPTS'
export const LOAD_BILLS = 'FETCH_BILLS'
export const DOC_FAILURE = 'DOC_FAILURE'
export const DOC_LOADING = 'DOC_LOADING'

//billings.js
export const LOAD_BILLINGS = 'FETCH_BILLINGS'
export const ADD_BILLING = 'ADD_BILLING'
export const UPDATE_BILLING = 'UPDATE_BILLING'
export const BILLING_FAILURE = 'BILLING_FAILURE'
export const BILLING_LOADING = 'BILLING_LOADING'



//attendances.js
export const LOAD_ATTENDANCES = 'FETCH_ATTENDANCES'
export const ADD_ATTENDANCE = 'ADD_ATTENDANCE'
export const ATTENDANCE_FAILURE = 'ATTENDANCE_FAILURE'
export const ATTENDANCE_LOADING = 'ATTENDANCE_LOADING'
export const SET_AS = 'SET_AS'

//admin
export const LOAD_ADMINS = 'FETCH_ADMINS'
export const ADD_ADMIN = 'ADD_ADMIN'
export const UPDATE_ADMIN = 'UPDATE_ADMIN'
export const DELETE_ADMIN = 'DELETE_ADMIN'
export const ADMIN_FAILURE = 'ADMIN_FAILURE'
export const ADMIN_LOADING = 'ADMIN_LOADING'

//settings.js
export const LOAD_SETTINGS = 'FETCH_SETTINGS'
export const ADD_SETTING = 'ADD_SETTING'
export const SETTING_FAILURE = 'SETTING_FAILURE'
export const SETTING_LOADING = 'SETTING_LOADING'

//userroles.js
export const LOAD_USERROLES = 'FETCH_USERROLES'
export const ADD_USERROLE = 'ADD_USERROLE'
export const UPDATE_USERROLE = 'UPDATE_USERROLE'
export const DELETE_USERROLE = 'DELETE_USERROLE'
export const USERROLE_FAILURE = 'USERROLE_FAILURE'
export const USERROLE_LOADING = 'USERROLE_LOADING'

// feestr.js
export const LOAD_FEESTRS = 'FETCH_FEESTRS'
export const ADD_FEESTR = 'ADD_FEESTRS'
export const UPDATE_FEESTR = 'UPDATE_FEESTRS'
export const DELETE_FEESTR = 'DELETE_FEESTRS'
export const FEESTR_FAILURE = 'FEESTR_FAILURE'
export const FEESTR_LOADING = 'FEESTR_LOADING'

// feepayments.js
export const LOAD_FEEPAYMENTS = 'FETCH_FEEPAYMENTS'
export const ADD_FEEPAYMENT = 'ADD_FEEPAYMENTS'
export const UPDATE_FEEPAYMENT = 'UPDATE_FEEPAYMENTS'
export const DELETE_FEEPAYMENT = 'DELETE_FEEPAYMENTS'
export const FEEPAYMENT_FAILURE = 'FEEPAYMENT_FAILURE'
export const FEEPAYMENT_LOADING = 'FEEPAYMENT_LOADING'
export const SET_ARREARS = 'SET_ARREARS'

// adcharge.js
export const LOAD_ADCHARGES = 'FETCH_ADCHARGES'
export const ADD_ADCHARGE = 'ADD_ADCHARGES'
export const UPDATE_ADCHARGE = 'UPDATE_ADCHARGES'
export const DELETE_ADCHARGE = 'DELETE_ADCHARGES'
export const ADCHARGE_FAILURE = 'ADCHARGE_FAILURE'
export const ADCHARGE_LOADING = 'ADCHARGE_LOADING'


// ledgeracc.js
export const LOAD_LEDGERACCS = 'FETCH_LEDGERACCS'
export const ADD_LEDGERACC = 'ADD_ADCHARGES'
export const UPDATE_LEDGERACC = 'UPDATE_LEDGERACCS'
export const DELETE_LEDGERACC = 'DELETE_LEDGERACCS'
export const LEDGERACC_FAILURE = 'LEDGERACC_FAILURE'
export const LEDGERACC_LOADING = 'LEDGERACC_LOADING'


//reports.js
export const LOAD_REVENUERPT = 'LOAD_REVENUERPT'
export const LOAD_EXPENSESRPT = 'LOAD_EXPENSESRPT'
export const LOAD_BANKINGRPT = 'LOAD_BANKINGRPT'
export const RPT_LOADING = 'RPT_LOADING'
export const RPT_FAILURE = 'RPT_FAILURE'



// WEBPACK FOOTER //
// ./resources/assets/js/store/mutation-types.js